import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CopilotState } from './copilot.reducer';

export const selectCopilotState = createFeatureSelector<CopilotState>('copilot');

export const selectedClientId = createSelector(
  selectCopilotState,
  (state) => state.selectedClientId
);

export const selectedClient = createSelector(
  selectCopilotState,
  selectedClientId,
  (state, clientId) => clientId ? state.clients[clientId] : undefined
);

export const selectedConversationId = createSelector(
  selectedClient,
  (client) => client?.selectedConversationId ?? null
);

export const selectMessagesForSelectedConversation = createSelector(
  selectedClient,
  (client) => {
    if (!client || !client.selectedConversationId) return [];
    return client.messages?.[client.selectedConversationId] ?? [];
  }
);

export const selectIsStreaming = (conversationId: string) =>
  createSelector(
    selectedClient,
    (client) => !!client?.isStreaming?.[conversationId]
  );

export const selectMessagesByConversation = (clientId: string, conversationId: string) =>
  createSelector(
    selectCopilotState,
    state => {
      const client = state.clients?.[clientId];
      const messages = client?.messages?.[conversationId];
      return Array.isArray(messages) ? messages : [];
    }
  );

export const selectHighlightedClientIds = createSelector(
  selectCopilotState,
  (state) => state.highlightedClientIds
);

export const selectInputTextForConversation = (clientId: string, conversationId: string) =>
  createSelector(
    selectCopilotState,
    (state) => {
      const client = state.clients?.[clientId];
      return client?.inputTextByConversation?.[conversationId] ?? '';
    }
  );

export const selectHighlightedConversations = createSelector(
  selectCopilotState,
  (state) => state.highlightedConversations
);
